"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilteredResultsCountMessage = FilteredResultsCountMessage;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableHeaderCell = require("./TableHeaderCell");

var _filterUtils = require("./filterUtils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line complexity, max-statements


function getMessageText(props) {
  var entityNames = props.entityNames ? props.entityNames : props.labels.rows;
  var executionTime = props.executionTime ? "(".concat(props.executionTime, ")") : '';

  if (props.totalResultCount && (!(0, _filterUtils.areAllColumnFiltersEmpty)(props.columnFilters) || props.isFilterApplied)) {
    return "".concat(props.labels.filteredResultsCountMessage).concat(props.partialCount, "\n        ").concat(props.labels.of).concat(props.totalResultCount, " ").concat(entityNames, "         ").concat(executionTime);
  }

  if (!(0, _filterUtils.areAllColumnFiltersEmpty)(props.columnFilters) || props.isFilterApplied) {
    return "".concat(props.labels.filteredResultsCountMessage).concat(props.partialCount, " ").concat(entityNames, " ").concat(executionTime);
  }

  if (!!props.thresholdCount && props.totalResultCount >= props.thresholdCount) {
    return "".concat(props.labels.resultsMessageTruncated).concat(props.totalResultCount, " ").concat(entityNames, " ").concat(executionTime);
  }

  if (props.totalResultCount) {
    return "".concat(props.labels.resultsMessage).concat(props.totalResultCount, " ").concat(entityNames, " ").concat(executionTime);
  }

  return "".concat(props.labels.filteredResultsCountMessageNoFilter, " ").concat(executionTime);
}

function FilteredResultsCountMessage(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement(_TableHeaderCell.TableHeaderCell, {
      colSpan: props.colspan,
      style: {
        textAlign: 'right'
      }
    }, getMessageText(props))
  );
}
/* eslint-disable react/no-unused-prop-types */


FilteredResultsCountMessage.propTypes = {
  colspan: _propTypes["default"].number.isRequired,
  columnFilters: _propTypes["default"].instanceOf(Object).isRequired,
  labels: _propTypes["default"].shape({
    filteredResultsCountMessage: _propTypes["default"].string,
    of: _propTypes["default"].string,
    filteredResultsCountMessageNoFilter: _propTypes["default"].string,
    resultsMessage: _propTypes["default"].string,
    resultsMessageTruncated: _propTypes["default"].string
  }).isRequired,
  partialCount: _propTypes["default"].number.isRequired,
  entityNames: _propTypes["default"].string,
  executionTime: _propTypes["default"].string,
  isFilterApplied: _propTypes["default"].bool,
  thresholdCount: _propTypes["default"].number,
  totalResultCount: _propTypes["default"].number
};
FilteredResultsCountMessage.defaultProps = {
  entityNames: null,
  executionTime: null,
  isFilterApplied: false,
  thresholdCount: null,
  totalResultCount: null
};